import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IntegrationNames = {
  CODAT_DYNAMICS_365_BUSINESS_CENTRAL:
    'urn:integration:backend:codat-dynamics-365-business-central',
  CODAT_NETSUITE: 'urn:integration:backend:codat-netsuite',
  CODAT_QUICKBOOKS_ONLINE: 'urn:integration:backend:codat-quickbooks-online',
  CODAT_QUICKBOOKS_ONLINE_SANDBOX:
    'urn:integration:backend:codat-quickbooks-online-sandbox',
  CODAT_SAGE_INTACCT: 'urn:integration:backend:codat-sage-intacct',
  CODAT_SANDBOX: 'urn:integration:backend:codat-sandbox',
  CODAT_XERO: 'urn:integration:backend:codat-xero',
  NETSUITE: 'urn:integration:backend:netsuite',
  PROCURIFY: 'urn:integration:backend:procurify',
  MERGE_QUICKBOOKS_ONLINE: 'urn:integration:backend:merge:quickbooks-online',
  MERGE_NETSUITE: 'urn:integration:backend:merge:netsuite',
} as const

export type IntegrationNameEnum = Enum<typeof IntegrationNames>
